import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import 'photoswipe/style.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';

import './style.scss';

const thumbElements = document.querySelectorAll('.gallery picture');

if (thumbElements.length > 0) {

    thumbElements.forEach(item => {

        const imgElement = item.querySelector('img');
        const anchorElement = document.createElement("a");
        anchorElement.href = imgElement.getAttribute('src');
        anchorElement.setAttribute("data-pswp-width", imgElement.getAttribute('width'));
        anchorElement.setAttribute("data-pswp-height", imgElement.getAttribute('height'));
        anchorElement.setAttribute("target", "_blank");


        imgElement.parentNode.insertBefore(anchorElement, imgElement);
        anchorElement.appendChild(imgElement);

        const captionDiv = document.createElement("div");
        captionDiv.className = "pswp-caption-content";
        captionDiv.innerHTML = `<b>${imgElement.title}</b><br/>${imgElement.alt}`;

        anchorElement.parentNode.insertBefore(captionDiv, anchorElement.nextSibling);

        const randomAngle = (Math.random() * 10) - 5;
        imgElement.style.transform = `rotate(${randomAngle}deg)`;


    });

    const lightbox = new PhotoSwipeLightbox({
        gallery: '.gallery',
        children: 'picture',
        pswpModule: () => import(/* webpackChunkName: "assets/photoswipe" */'photoswipe')
    });


    new PhotoSwipeDynamicCaption(lightbox, {
        type: 'auto',
    });

    lightbox.init();
}






